import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { maxHeight } from '@material-ui/system'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import { useGetWarehouseNameQuery } from 'generated/graphql'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'

export const ICListingWithStatusReport = () => {
    const history = useHistory()
    const {WarehouseID}: any = useParams()
    const user = JSON.parse(localStorage.getItem('loggedInUser'))
    const accountID = user.accountID
    let location = useLocation()
    const editData = location?.state as any

    const {
        loading: WarehouseLoading,
        error: WarehouseError,
        data: { getWarehouse } = { getWarehouse: [] },
    } = useGetWarehouseNameQuery({
        variables: { WarehouseID },
        fetchPolicy: 'network-only',
    })

    const parameters = [
        {name: 'accountid', value: accountID},
        {name: 'companyid', value: editData?.CompanyID ?? undefined},
        {name: 'docdate', 
         value: editData?.DocDate
            ? formatDashDate(new Date(editData?.DocDate).toISOString())
            : null,
        },
        {name: 'trxndate', 
         value: editData?.TrxnDate
            ? formatDashDate(new Date(editData?.TrxnDate).toISOString())
            : null,
        },
        { name: 'docno', value: editData?.DocNo ?? undefined },
        { name: 'refno', value: editData?.DocRef ?? undefined },
        { name: 'description', value: editData?.Description ?? undefined },
        { name: 'status', value: editData?.DocStatus},
        { name: 'doctype', value: editData?.DocType },
        { name: 'warehouse', value: editData?.WarehouseID },
        { name: 'docamt', value: editData?.DocAmt ?? undefined },
        { name: 'department', value: editData?.CostCentreID },
    ]

    const generatedurl = (reportName, parameters) => {
        let reporturl = reportName

        parameters?.map((x,index) => {
            const symbol = index === 0 ? '?' : '&'
            if (x?.value !== undefined)
                reporturl = reporturl + symbol + x?.name + '=' + x?.value
        })
        return reporturl
    }

    return (
        <>
            <MainHeader
                onClick={() => history.push(`/digital-reports/inventory-control`)}
                mainBtn="close"
                smTitle="Inventory Control"
                title={user?.accountName}
                routeSegments={[
                    { name: 'Main Menu' },
                    { name: 'Digital Reporting' },
                    { name: 'IC Listing With Status', current: true },
                ]}
                rightRouteSegments={[{ name: 'Report', current: true }]}
            />
            <ContentWrapper style={{ maxHeight: '100%' }}>
                {ReportViewer({
                    url: generatedurl('ICListingWithStatus', parameters),
                    host: accountxReportUrl,
                    excludedExportFormat: [],
                })}
            </ContentWrapper>
        </>
    )
}